// extracted by mini-css-extract-plugin
export default {"Popover":"GMnn_4lfIaulbq9F0WaQ","Arrow":"vkKBEZ70JYo0D0VJp8S0"};